import { Options, StrConfig } from '../overlays/configs/str'
import { AverageTrueRange } from './atr'
import { MainCalculation } from './main'

type DefaultCalculatedValuesType = {
  finalUpperBand: number[]
  finalLowerBand: number[]
  supertrend: boolean[]
}

export class StrCalculation extends MainCalculation<Options, DefaultCalculatedValuesType> {
  static config = StrConfig
  declare options: Options

  calculate() {
    const { period, multiplier } = this.options
    const { high, low, close } = this.quote
    const atr = new AverageTrueRange(period)
    const finalUpperBand: number[] = []
    const finalLowerBand: number[] = []
    const supertrend: boolean[] = []
    this._calculatedValues = this.getDefaultCalculatedValues()

    for (let i = 1; i < close.length; i++) {
      atr.add(high[i], low[i], close[i - 1])

      // compute bands
      const avg = (high[i] + low[i]) / 2
      const upperBand = avg + multiplier * atr.value
      const lowerBand = avg - multiplier * atr.value

      finalUpperBand[i] = upperBand
      finalLowerBand[i] = lowerBand

      // identify supertrend
      if (close[i] > finalUpperBand[i - 1]) {
        supertrend[i] = true
      } else if (close[i] < finalLowerBand[i - 1]) {
        supertrend[i] = false
      } else {
        supertrend[i] = supertrend[i - 1]
      }

      // adjust bands
      if (supertrend[i] && finalLowerBand[i] < finalLowerBand[i - 1]) {
        finalLowerBand[i] = finalLowerBand[i - 1]
      }
      if (!supertrend[i] && finalUpperBand[i] > finalUpperBand[i - 1]) {
        finalUpperBand[i] = finalUpperBand[i - 1]
      }
    }

    this._calculatedValues.finalLowerBand = finalLowerBand
    this._calculatedValues.finalUpperBand = finalUpperBand
    this._calculatedValues.supertrend = supertrend
  }
}
